import cn from 'classnames'
import * as React from 'react'
import styles from './FloatingToolbar.module.css'

export interface FloatingToolbarProps {
  children: React.ReactNode
  ariaLabel?: string
  className?: string
}

export interface FloatingToolbarItemProps {
  children: React.ReactNode
  className?: string
}

export interface FloatingToolbarDividerProps {
  className?: string
}

export function FloatingToolbar({ children, ariaLabel, className }: FloatingToolbarProps) {
  return (
    <div className={cn(styles.container, className)} role="region" aria-label={ariaLabel}>
      {children}
    </div>
  )
}

function FloatingToolbarItem({ children, className }: FloatingToolbarItemProps) {
  return <div className={cn(styles.item, className)}>{children}</div>
}

function FloatingToolbarDivider({ className }: FloatingToolbarDividerProps) {
  return <div className={cn(styles.divider, className)} />
}

FloatingToolbar.Item = FloatingToolbarItem
FloatingToolbar.Divider = FloatingToolbarDivider
